module.exports = __webpack_public_path__ + "static/img/age.16df51d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/age.jpg
// module id = QFz/
// module chunks = 3